export default "__VITE_ASSET__DrP16rlQ__"